import { render, staticRenderFns } from "./headerDoctor.vue?vue&type=template&id=0212b9cd&scoped=true&"
import script from "./headerDoctor.vue?vue&type=script&lang=js&"
export * from "./headerDoctor.vue?vue&type=script&lang=js&"
import style0 from "./headerDoctor.vue?vue&type=style&index=0&id=0212b9cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212b9cd",
  null
  
)

export default component.exports